import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { PurchaseOrderReceiptExceptionEntity } from './purchase-order-receipt-exception.entity';

/**
 * Link table between PurchaseOrderReceiptException and File. Used for
 * per-exception damage / wrong-item photos. These photos are inlined
 * into the vendor-receipt-issue email when the exception is notified
 * to the vendor (Phase 7).
 */
@Index('po_receipt_exception__file__fk__file__id_fk', ['fkFileId'], {})
@Index('po_receipt_exception__file__fk_exception__id_fk', ['fkExceptionId'], {})
@Entity('purchase_order_receipt_exception__file')
export class PurchaseOrderReceiptExceptionFileEntity extends BaseEntity {
	@Column('int', {
		name: 'fk_purchase_order_receipt_exception__id',
		unsigned: true,
	})
	public fkExceptionId!: number;

	@Column('int', { name: 'fk__file__id', unsigned: true })
	public fkFileId!: number;

	/** Optional human-readable label ("Front view, crushed corner", "Wrong NDC label"). */
	@Column('varchar', { name: 'caption', length: 255, nullable: true })
	public caption!: string | null;

	@ManyToOne(() => PurchaseOrderReceiptExceptionEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([
		{
			name: 'fk_purchase_order_receipt_exception__id',
			referencedColumnName: 'id',
		},
	])
	public fkException!: PurchaseOrderReceiptExceptionEntity;

	@ManyToOne(() => FileEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
